<template>
  <div class="">
    <div class="game-mc">
      <div class="game-mc__box">
        <div class="game-mc__box__media">
          <image-loader :src="question.img"/>
        </div>
        <div class="game-mc__box__question">
          <div class="select_question select_question-red container align-items-stretch">
            <div class="img container align-center">
              <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
            </div>
            <div class="flex-grow-1 bordered-box bordered-box-orange">
              <p>{{ question.question }}</p>
            </div>
          </div>
          <div class="game-mc__box__question__answers select-question__right">
            <ul class="list-none relative">
              <div class="block__game" v-if="ended"></div>
              <li v-for="(x, ind) in question.answers" :key="ind" class="animation-bottom" :style="{animationDelay: (ind / 20) + 's'}">
                <div
                  class="select-question__item container align-items-center"
                  @click="select(x)"
                  :class="{ correct : question.answered && x.correct, wrong: question.answered && !x.correct && x.selected}"
                  ref="options">
                  <div class="index">
                    {{ind + 1}}
                  </div>

                  <span class="input_check" :class="{active : x.selected}"></span>
                  {{x.text}}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container align-items-center justify-content-end">
        <button class="btn btn-blue btn-rounded" @click="confirm(question)" :disabled="question.answered">Confirm</button>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>
<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      index: 0,
      question: {},
      showInfo: false,
      showFeedback: false,
      ended: false,
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    questions () {
      return this.subTopic.exercise.questions
    }
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    async setCurrent () {
      let index = 0
      let qst = {}
      for (const key in this.questions) {
        index = key
        if (!this.questions[key].answered) {
          qst = this.questions[key]
          break
        } else if (key == (this.questions.length - 1)) {
          qst = this.questions[key]
          this.ended = true
        }
      }
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
        this.index = index
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    select (answer) {
      if (!this.question.answered) {
        this.$set(answer, 'selected', !answer.selected)
      }
    },
    async save (question) {
      let scoreQuestions = 0,
          questionScore  = 0,
          answered       = 0,
          correctCount   = 0

      for (const qst of this.questions) {
        if (qst.answered) {
          for (const aswr of qst.answers) {
            if (aswr.correct) {
              correctCount++

              if (aswr.selected)
                questionScore++
            } else {
              if (aswr.selected)
                questionScore--
            }
          }

          if (questionScore < 0)
            questionScore = 0

          answered++
          scoreQuestions += ((questionScore * 100) / correctCount)
          questionScore = 0
          correctCount = 0
        }
      }

      const score = (scoreQuestions)/this.questions.length

      let payload = {
        points: score,
        finished: false,
        question: question
      }

      if (answered == this.questions.length) {
        payload.finished = true
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit('updateProgress', score)
      gameBus.$emit("setEnabled", true)

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch('subTopic/answerQuestion', payload)
    },
    confirm (question) {
      let questionScore = 0
      let correctCount = 0
      for (const aswr of question.answers) {
        if (aswr.correct) {
          correctCount++
          if (aswr.selected) questionScore++
        } else {
          if (aswr.selected) questionScore--
        }
      }
      if (questionScore < 0) questionScore = 0
      let score = ((questionScore * 100) / correctCount)
      this.$set(question, 'hit', score >= 70 )
      this.$set(question, 'answered', true)
      this.feedback()
      this.save(question)
    },
    async viewQuestion (index) {
      const question = this.questions[index]
      if (question && question.answered) {
        this.index = index
        this.$set(this, 'question', question)
      }
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    }
  },
  watch: {
    ended (val) {
      gameBus.$emit('setEnded', val)
    },
    index (val) {
      gameBus.$emit('updateIndex', val)
    },
    testMode (val) {
      this.setCurrent()
    }
  },
  mounted () {
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion)

    gameBus.$emit("updateProgress", this.subTopic.points)
    modalBus.$on("close", this.closeModal)
    gameBus.$on("setCurrent", this.setCurrent)
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off("setCurrent", this.setCurrent)
  }
}
</script>
<style lang="scss">
  @import './src/assets/css/components/selectQuestion';
  @import './src/assets/css/components/answerSelectQuestion';
  $color-red: #c2003c;

  .game-mc {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: stretch;
    align-items: stretch;
    flex-direction: column;
    &__box {
      flex-basis: 100%;
      display: flex;
      &__media {
        flex-basis: 55%;
      }
      &__question {
        flex-basis: 45%;
        display: flex;
        flex-direction: column;
        padding-left: 15px;
        &__text {
          text-align: left;
          flex-basis: calc(20% - 20px);
          padding: 10px 25px;
          display: flex;
          span {
            align-self: center;
            vertical-align: middle;
            font-weight: 600;
          }
        }
        &__answers {
          flex-basis: 70%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/game/multipleChoiceGame.vue